export var SCREEN_SIZE;
(function (SCREEN_SIZE) {
    SCREEN_SIZE[SCREEN_SIZE["XS"] = 480] = "XS";
    SCREEN_SIZE[SCREEN_SIZE["SM"] = 640] = "SM";
    SCREEN_SIZE[SCREEN_SIZE["MD"] = 768] = "MD";
    SCREEN_SIZE[SCREEN_SIZE["LG"] = 1024] = "LG";
    SCREEN_SIZE[SCREEN_SIZE["XL"] = 1200] = "XL";
    SCREEN_SIZE[SCREEN_SIZE["XXL"] = 1800] = "XXL";
})(SCREEN_SIZE || (SCREEN_SIZE = {}));
//# sourceMappingURL=responsive.js.map